// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const TextBlock = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 100 60" width="1em" height="1em" {...props}>
    <path d="M64.2 13.2H35.8c-.3 0-.6.2-.7.6v3.9c.1.4.4.6.8.6.3 0 .5-.3.6-.6v-3.2h12.9v31.3H46c-.3-.1-.6.2-.7.5s.2.6.5.7H54.1c.3.1.6-.2.7-.5.1-.3-.2-.6-.5-.7h-3.6V14.4h12.9v3.2c.1.4.4.6.8.6.3 0 .5-.3.6-.6v-3.9c-.2-.3-.5-.5-.8-.5z" />
  </svg>
);

export default TextBlock;
